import axios from 'axios'
import { Base64 } from 'js-base64';
import {ElMessageBox} from 'element-plus'

// 创建通用axios配置
let instance = axios.create({
	responseType:"json",
	headers:{'Content-Type':'application/json'}
})

// 对token加密
function baseFun(){
	const token = localStorage.getItem('token')
	return 'Bearer '+token
}

// 请求拦截器
instance.interceptors.request.use(
	config => {
		let token = localStorage.getItem('token')
		if(token){
			config.headers.Authorization = baseFun()
		}
		return config
	},
	err => {
		return Promise.reject(err)
	}
)

// 响应拦截器
instance.interceptors.response.use(
	response => {
		return response
	},
	error => {
		if(error.response){
			let ERRS = error.response.status
			let MSG = '还未登录，请先登录'
			let errdata = ERRS == 401 ? MSG : '服务器发生错误'
			console.log('接口错误:', errdata, ERRS)
			switch (ERRS){
				case 401:
					// 处理401
					break;
			}
		} else {
			// 网络错误、跨域、请求被浏览器拦截
			console.error('请求失败:', error.message)
		}
		
		// ✅ 始终返回完整的 error 对象
		return Promise.reject(error)
	}
)

export default instance